import React from "react";
import PropTypes from "prop-types";

import { useBuildSearchParams } from "routes/hooks";
import { Button } from "semantic-ui-react";

export function NavigateButton({ children, urlParams, link, ...props }) {
  const buildSearchParams = useBuildSearchParams();

  return (
    <Button
      primary
      as="a"
      href={`${link}?${buildSearchParams(urlParams).toString()}`}
      target="_blank"
      style={{
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        overflow: "hidden",
      }}
      {...props}
    >
      {children}
    </Button>
  );
}

NavigateButton.propTypes = {
  children: PropTypes.node,
  link: PropTypes.string.isRequired,
  urlParams: PropTypes.arrayOf(PropTypes.array),
};

NavigateButton.defaultProps = { urlParams: [], children: undefined };

export default NavigateButton;
